export enum PERMISSION {
  CREATE_PROJECT = "Create project",
  EDIT_PROJECT = "Edit project",
  VIEW_PROJECTS = "View projects",
  DELETE_PROJECT = "Delete project",

  CREATE_PROCEDURE = "Create procedure",
  EDIT_PROCEDURE = "Edit procedure",
  VIEW_PROCEDURES = "View procedures",
  DELETE_PROCEDURE = "Delete procedure",
  ASSIGN_PROCEDURE = "Assign procedure",
  SEMANTIC_SEARCH_PROCEDURES = "Semantic search procedures",

  CREATE_SURVEY = "Create survey",
  EDIT_SURVEY = "Edit survey",
  VIEW_SURVEYS = "View surveys",
  DELETE_SURVEY = "Delete survey",
  ASSIGN_SURVEY = "Assign survey",

  CREATE_MEETING = "Create meeting",
  EDIT_MEETING = "Edit meeting",
  VIEW_MEETINGS = "View meetings",
  DELETE_MEETING = "Delete meeting",

  CREATE_USER = "Create user",
  EDIT_USER = "Edit user",
  VIEW_USERS = "View users",
  DELETE_USER = "Delete user",

  CREATE_GOAL = "Create goal",
  EDIT_GOAL = "Edit goal",
  VIEW_GOALS = "View goals",
  DELETE_GOAL = "Delete goal",
  ASSIGN_GOAL = "Assign goal",

  CREATE_RECOGNITION = "Create recognition",
  EDIT_RECOGNITION = "Edit recognition",
  VIEW_RECOGNITIONS = "View recognitions",
  DELETE_RECOGNITION = "Delete recognition",

  CREATE_COMMENT = "Create comment",
  EDIT_COMMENT = "Edit comment",
  VIEW_COMMENTS = "View comments",
  DELETE_COMMENT = "Delete comment",

  CONTRACTOR_MODE = "Contractor Mode",
  TEAM_LEAD_MODE = "Team Lead Mode",
  SYNC_TEAM_WITH_HARVEST = "Sync Team With Harvest",

  USE_PROCEDURE_ASSISTANT = "Use procedure assistant",

  // Byte-identical to the API's seeded permission row (api/app/shared/constants/permission.ts) —
  // checkPermission compares names as plain strings, so a casing slip here fails open-ended, silently.
  RUN_EVALUATIONS = "Run evaluations",
  VIEW_PROCEDURE_INDEX_STATUS = "View procedure index status",

  // SPARK Rewards. Granted to HR + Super Admin (Phase 03) — byte-identical to the API's seeded
  // permission rows (api/app/shared/constants/permission.ts).
  MANAGE_REWARD_CONFIG = "Manage reward config",
  VIEW_LEADERBOARDS = "View leaderboards",
  MANAGE_REDEMPTIONS = "Manage redemptions",
  VIEW_REDEMPTIONS = "View redemptions",
  MANAGE_SEASONAL_QUESTS = "Manage seasonal quests",
  VIEW_BADGES = "View badges",

  // Admin Settings (Phase 2) -- byte-identical to the API's seeded permission row
  // (api/app/shared/constants/permission.ts). Super Admin only (Phase 1a decision).
  MANAGE_APP_SETTINGS = "Manage app settings",

  // Audit log -- byte-identical to the API's seeded permission row
  // (api/app/shared/constants/permission.ts). Super Admin only.
  VIEW_AUDIT_LOG = "View audit log",
}
